<template>
  <v-card height="210">
    <v-layout>
      <v-flex xs5 pt-2>
        <v-img :src="book.image" height="190px" contain></v-img>
      </v-flex>
      <v-flex xs7>
        <v-card-title>
          <div style="height: 120px">
            <div class="text-uppercase font-weight-bold" contain>{{ book.title.substr(0, 40) }}</div>
            <div class="mt-3">Autor: {{ book.author.substr(0, 15) }}...</div>
            <div class="hidden-xs-only">Editorial: {{ book.editorial.name.substr(0, 14) }}...</div>
            <div>Stock: {{ book.stock }} unidades</div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn round class="white--text btn-reservar" @click="goToShowBook(book.id)">Reservar</v-btn>
        </v-card-actions>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    book: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToShowBook(id) {
      this.$router.push({
        name: "book-show",
        params: { id: id }
      });
    }
  }
};
</script>

<style>
.btn-reservar {
  background: #789c4a !important;
  border-color: #789c4a !important;
}
</style>